import { CustomerDto } from './customer-model';
import { CrewDto } from './crew-model';
import { ProjectDto } from './project-model';

export class DashboardDto {
  openJobs: ProjectDto[] = [];
  closedJobs: ProjectDto[] = [];
  customersWithOpenJobs: CustomerDto[] = [];
  crewsWithOpenJobs: CrewDto[] = [];
  assignedJobs: ProjectDto[] = [];
}